<div class="tw-space-y-5">
  <p class="tw-text-gray tw-text-center tw-font-bold tw-font-mulish">{{ cfg.data?.message }}</p>
  <div class="p-fluid tw-flex tw-flex-col tw-items-center tw-gap-1">
    <div class="p-fluid tw-w-[290px]">
      <p-button [label]="cfg.data?.acceptLabel" styleClass="tw-primary-button" (click)="close(true)" />
    </div>
    <div *ngIf="cfg.data?.rejectLabel" class="p-fluid tw-w-[290px]">
      <p-button [label]="cfg.data?.rejectLabel" styleClass="tw-secondary-button" (click)="close(false)" />
    </div>
  </div>
</div>